import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20dramatic%20red%20velvet%20curtains%20and%20warm%20golden%20spotlight%2C%20grand%20stage%20with%20film%20projection%20light%20beams%2C%20atmospheric%20dark%20elegant%20interior%2C%20warm%20amber%20and%20crimson%20tones%2C%20cinematic%20lighting%20with%20soft%20shadows&width=1600&height=800&seq=hero-bg-movie&orientation=landscape"
          alt="光影在线 - 免费电影在线观看高清全集"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 tracking-tight">
          免费电影在线观看
        </h1>
        <p className="text-sm md:text-base text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          海量高清影片资源随时畅享，无需下载、无需注册，支持手机电脑多端播放
          <br className="hidden sm:block" />
          涵盖最新院线大片、经典老片、国产剧、欧美影视等全品类
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/kehuan"
            className="w-full sm:w-auto px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观影
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 font-semibold text-sm hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer text-center border border-background-50/30"
          >
            <i className="ri-information-line mr-2"></i>
            了解更多
          </Link>
        </div>

        <div className="flex items-center justify-center gap-6 mt-10 flex-wrap">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">10000+</p>
            <p className="text-xs text-background-300 mt-1">高清影片</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">30+</p>
            <p className="text-xs text-background-300 mt-1">影片分类</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-background-50">500万+</p>
            <p className="text-xs text-background-300 mt-1">活跃用户</p>
          </div>
        </div>
      </div>
    </section>
  );
}